export default __webpack_public_path__ + "assets/windows.4b46485d.svg";